const it = {
  app_name: "Univers Libertin",
  app_tagline: "Il tuo spazio sicuro, discreto e gentile.",
  app_badge: "Adulti consenzienti · Comunità",
  loading: "Caricamento...",
  save: "Salva",
  cancel: "Annulla",
  delete: "Elimina",
  close: "chiudi",
  send: "Invia",
  search: "Cerca",
  go: "Vai",
  confirm_delete: "Eliminare questo post?",
  no_results: "Nessun risultato trovato.",
  error_generic: "Errore interno.",
  footer_trust: "Privacy totale · Moderazione IA · I tuoi dati non vengono mai venduti",

  nav_feed: "Feed",
  nav_directory: "Annuario",
  nav_encounters: "Incontri",
  nav_places: "Luoghi",
  nav_messages: "Messaggi",
  nav_premium: "Premium",
  nav_profile: "Profilo",
  nav_blog: "Blog",
  nav_logout: "Disconnetti",

  age_gate_title: "Solo per adulti",
  age_gate_desc: "Univers Libertin è una piattaforma comunitaria per adulti consenzienti. L'accesso è riservato alle persone maggiorenni (18 anni e oltre).",
  age_gate_confirm: "Certifico di avere 18 anni o più — Entra",
  age_gate_deny: "Sono minorenne — Esci",

  charter_title: "Carta del consenso",
  charter_desc: "Impegnati a rispettare questi principi fondamentali per accedere alla comunità.",
  charter_accept_all: "Accetto la carta — Continua",
  charter_accept_pending: "Accetta tutti e 3 gli impegni",
  charter_rule_consent_title: "Consenso assoluto",
  charter_rule_consent_desc: "Dichiaro di essere maggiorenne (+18). Mi impegno a rispettare il consenso di ogni persona in ogni circostanza. Un «no» o un silenzio non è mai un «sì». Nessuna pressione, insistenza o manipolazione sarà tollerata.",
  charter_rule_discretion_title: "Riservatezza totale",
  charter_rule_discretion_desc: "Ciò che accade su Univers Libertin resta su Univers Libertin. Non condividerò mai l'identità, le foto, le informazioni o le attività di un altro membro senza il suo consenso esplicito. Nessun outing.",
  charter_rule_respect_title: "Rispetto e gentilezza",
  charter_rule_respect_desc: "Rispetto i limiti, le pratiche e le scelte di ciascuno senza giudicare. Nessun body-shaming, slut-shaming, kink-shaming o discriminazione di alcun tipo. Ognuno è libero nei propri desideri e nei propri limiti.",
  charter_read_again: "← Rileggi la carta",

  auth_login: "Accedi",
  auth_signup: "Registrati",
  auth_pseudo: "Nome utente",
  auth_pseudo_placeholder: "Il tuo nome utente discreto",
  auth_pseudo_hint: "Scegli un nome utente — mai il tuo vero nome.",
  auth_email: "Email",
  auth_email_placeholder: "tua@email.com",
  auth_password: "Password",
  auth_password_placeholder: "Minimo 8 caratteri",
  auth_login_btn: "Accedi",
  auth_signup_btn: "Unisciti alla comunità",
  auth_logging_in: "Accesso in corso...",
  auth_signing_up: "Creazione...",
  auth_signup_success: "Account creato! Ora puoi accedere.",

  feed_placeholder: "Come ti senti? Condividi in sicurezza...",
  feed_publish: "Pubblica",
  feed_analyzing: "Analisi...",
  feed_char_count: "{count}/2000 — Moderato da IA",
  feed_empty: "Nessun post per il momento. Sii il/la primo/a a condividere.",
  feed_moderation_warning: "Il tuo messaggio non è conforme alla nostra carta.",

  mood_neutral: "Neutro",
  mood_happy: "Felice",
  mood_sad: "Triste",
  mood_anxious: "Ansioso/a",
  mood_grateful: "Grato/a",
  mood_angry: "Arrabbiato/a",
  mood_hopeful: "Pieno/a di speranza",

  directory_title: "Annuario",
  directory_desc: "Esplora la comunità con discrezione.",
  directory_search_placeholder: "Cerca per città...",
  directory_filter_all: "Tutti",
  directory_no_profiles: "Nessun profilo trovato.",
  directory_send_message: "Invia un messaggio →",
  directory_looking_for: "Cerca:",
  directory_interests: "Interessi:",

  filter_gender: "Genere",
  filter_orientation: "Orientamento",
  filter_status: "Situazione",
  filter_all_genders: "Tutti",
  filter_all_orientations: "Tutti",
  filter_all_statuses: "Tutti",

  gender_unset: "Non specificato", gender_man: "Uomo", gender_woman: "Donna", gender_nb: "Non binario", gender_other: "Altro",
  orientation_unset: "Non specificato", orientation_hetero: "Etero", orientation_bi: "Bi", orientation_gay: "Gay", orientation_lesbian: "Lesbica", orientation_pan: "Pan", orientation_curious: "Curioso/a", orientation_other: "Altro",
  status_unset: "Non specificato", status_solo: "Single", status_couple: "In coppia", status_open: "Coppia aperta", status_poly: "Poliamoroso/a", status_other: "Altro",
  level_unset: "Non specificato", level_curious: "Curioso/a", level_beginner: "Principiante", level_experienced: "Esperto/a", level_confirmed: "Avanzato/a",

  profile_title: "Il mio profilo", profile_desc: "Personalizza la tua presenza. Solo il tuo nome utente è visibile, mai la tua email.",
  profile_avatar: "Avatar", profile_photos: "Foto del profilo",
  profile_photos_hint: "Puoi sfocare alcune foto. Passa a Premium per caricarne di più.",
  profile_identity: "Identità", profile_display_name: "Nome visualizzato", profile_display_name_placeholder: "Soprannome",
  profile_bio: "Bio", profile_bio_placeholder: "Descriviti, i tuoi desideri, cosa ti attrae...",
  profile_city: "Città", profile_city_placeholder: "La tua città", profile_age: "Età", profile_experience: "Esperienza",
  profile_department: "Dipartimento", profile_department_unset: "Non specificato",
  profile_region: "Regione", profile_region_unset: "Non specificato",
  profile_looking_for: "Cerco", profile_interests: "Interessi", profile_interests_add: "Aggiungi...",
  profile_boundaries: "I miei limiti e parole di sicurezza",
  profile_boundaries_placeholder: "Ciò che non desideri, i tuoi limiti chiari, la tua parola di sicurezza...",
  profile_boundaries_hint: "I tuoi limiti sono visibili agli altri membri e saranno rispettati.",
  profile_privacy: "Privacy",
  profile_visible: "Visibile nell'annuario", profile_visible_desc: "Disattiva per nascondere il tuo profilo.",
  profile_show_age: "Mostra la mia età", profile_show_age_desc: "La tua età sarà visibile sul tuo profilo.",
  profile_allow_messages: "Accetta messaggi privati", profile_allow_messages_desc: "Permetti agli altri membri di scriverti.",
  profile_save: "Salva il mio profilo", profile_saving: "Salvataggio...", profile_saved: "Profilo salvato!",

  looking_discussions: "Discussioni", looking_friendship: "Amicizia libertina", looking_soft: "Incontri soft",
  looking_parties: "Feste private", looking_couple: "Piano coppia", looking_solo: "Piano singolo",
  looking_swinging: "Scambismo", looking_melangisme: "Scambismo soft", looking_voyeur: "Voyeurismo/Esibizionismo",
  looking_bdsm: "BDSM", looking_poly: "Poliamore", looking_clubs: "Uscite in club",

  encounters_title: "Incontri", encounters_desc: "Proponi o partecipa a eventi.",
  encounters_propose: "+ Proponi", encounters_new: "Nuova proposta",
  encounters_title_placeholder: "Titolo (es: Serata libertina soft a Milano)",
  encounters_desc_placeholder: "Descrivi l'evento, l'atmosfera, le tue aspettative...",
  encounters_category: "Categoria", encounters_who: "Chi può partecipare",
  encounters_city: "Città", encounters_date: "Data e ora", encounters_max: "Max partecipanti",
  encounters_location: "Luogo (nome del club, indirizzo, link...)",
  encounters_dresscode: "Dress code (opzionale)", encounters_online: "Online",
  encounters_rules: "Regole dell'evento (opzionale)", encounters_publish: "Pubblica proposta",
  encounters_creating: "Creazione...", encounters_created: "Proposta creata!",
  encounters_join: "Partecipa →", encounters_join_placeholder: "Presentati brevemente...",
  encounters_request_sent: "Richiesta inviata!", encounters_empty: "Nessun incontro per il momento.",
  encounters_open: "Aperto", encounters_full: "Completo",
  encounters_places: "{count}/{max} posti", encounters_by: "di {name} · {date}",
  encounters_date_flexible: "Data flessibile",

  cat_all: "Tutte", cat_soiree: "Festa privata", cat_club: "Club", cat_meetup: "Incontro",
  cat_afterwork: "After-work", cat_sauna: "Sauna / Spa", cat_voyage: "Viaggio", cat_weekend: "Weekend",
  cat_online: "Online", cat_couple_seek: "Cerca coppia", cat_soft: "Soft / Scoperta",
  cat_discussion: "Discussione", cat_other: "Altro",

  who_all: "Aperto a tutti", who_couples: "Solo coppie", who_men: "Solo uomini",
  who_women: "Solo donne", who_couples_women: "Coppie e donne", who_verified: "Profili verificati",

  places_title: "Luoghi", places_desc: "Luoghi libertini consigliati dalla comunità.",
  places_add: "+ Aggiungi", places_suggest: "Suggerisci un luogo", places_name: "Nome del luogo",
  places_name_desc: "Descrivi il luogo, l'atmosfera, cosa lo rende speciale...",
  places_category: "Categoria", places_city: "Città",
  places_department: "Dipartimento", places_department_select: "Seleziona...",
  places_region: "Regione", places_region_auto: "Auto", places_region_all: "Tutto il paese",
  places_price: "Prezzo", places_address: "Indirizzo completo (opzionale)", places_website: "Sito web (opzionale)",
  places_features: "Servizi e caratteristiche", places_submit: "Invia", places_submitting: "Invio...",
  places_submitted: "Luogo inviato!", places_empty: "Nessun luogo trovato.",
  places_reviews: "recensioni", places_review_cta: "Lascia una recensione →",
  places_review_general: "Generale", places_review_ambiance: "Atmosfera",
  places_review_respect: "Rispetto", places_review_hygiene: "Igiene",
  places_review_placeholder: "La tua esperienza...", places_review_publish: "Pubblica",
  places_review_published: "Recensione pubblicata!", places_verified: "✓ Verificato",
  places_search_placeholder: "Cerca per città...",

  pcat_all: "Tutti", pcat_club: "Club libertino", pcat_sauna: "Sauna / Spa", pcat_bar: "Bar",
  pcat_hotel: "Hotel", pcat_beach: "Spiaggia / Natura", pcat_camping: "Campeggio",
  pcat_restaurant: "Ristorante", pcat_association: "Associazione", pcat_boutique: "Negozio",
  pcat_online: "Online", pcat_other: "Altro",

  price_unset: "Non specificato", price_free: "Gratis", price_low: "€ (< 30€)", price_mid: "€€ (30-80€)", price_high: "€€€ (> 80€)",

  messages_title: "Messaggi", messages_desc: "Le tue conversazioni private e discrete.",
  messages_empty: "Nessuna conversazione.", messages_go_directory: "Vai all'annuario →",
  messages_conversation: "Conversazione",
  messages_start: "Inizio della conversazione. Sii rispettoso/a e gentile.",
  messages_placeholder: "Il tuo messaggio...", messages_not_allowed: "Questo membro non accetta messaggi privati.",
  messages_moderation: "Messaggio non conforme alla carta.",

  premium_title: "Passa a Premium", premium_desc: "Sblocca tutte le funzionalità.",
  premium_current: "Attuale", premium_choose: "Scegli {name}", premium_manage: "Gestisci abbonamento",
  premium_redirecting: "Reindirizzamento...",
  premium_success: "Benvenuto/a nel piano {plan}!",
  premium_footer: "Pagamento sicuro con Stripe · Cancella quando vuoi · Senza impegno",
  premium_active_until: "Il tuo abbonamento {name} è attivo fino al {date}.",
  plan_free: "Gratis", plan_premium: "Premium", plan_vip: "VIP", plan_month: "/mese",

  photos_drop: "Clicca o trascina un'immagine (JPG, PNG, WebP · max 5 MB)",
  photos_count: "{current}/{max} foto", photos_uploading: "Caricamento...",
  photos_limit: "Limite di {max} foto raggiunto (piano {plan}).",
  photos_confirm_delete: "Eliminare questa foto?",

  visitors_title: "Chi ha visitato il mio profilo",
  visitors_count: "visite recenti",
  visitors_upsell: "Passa a Premium per scoprire chi è interessato a te.",
  visitors_none: "Nessuna visita recente.",
  nav_pro: "Pro",
  nav_visitors: "Visitatori",
  pro_title: "Dashboard Pro",
  pro_desc: "Gestisci i tuoi locali rivendicati.",
  pro_claim: "È il mio locale",
  pro_no_places: "Nessun locale rivendicato.",
  pro_pending: "Richieste in attesa",
  spotlight_label: "Spotlight",
  spotlight_buy: "⭐ Boost 24h — 2,99€",
  spotlight_active: "In evidenza",

};

export default it;
